import React from 'react';
import * as Styles from './InputStyles';

interface Props {
  readonly name: string;
  readonly label: string;
  readonly placeholder?: string;
  readonly height?: number;
  readonly required?: boolean;
  readonly type: string;
  readonly absolute?: boolean;
  readonly passwordHandlers?: {
    readonly passwordShow: boolean;
    readonly handlePasswordVisibility: () => void;
  };
  readonly errors?: string | undefined;
  onInputChange: (event: React.ChangeEvent<HTMLInputElement>) => any;
}

const Input: React.FC<Props> = ({
  name,
  label,
  absolute = true,
  placeholder,
  height = 100,
  errors,
  required,
  passwordHandlers,
  type,
  onInputChange,
}: Props) => {
  const ShowPassword = (): JSX.Element =>
    passwordHandlers?.passwordShow ? (
      <Styles.FaEyeSlashIcon onClick={passwordHandlers?.handlePasswordVisibility} />
    ) : (
      <Styles.FaEyeIcon onClick={passwordHandlers?.handlePasswordVisibility} />
    );

  return (
    <Styles.Container isAbsolute={absolute} height={height}>
      <Styles.Label htmlFor={name}>{label}</Styles.Label>
      <Styles.Input
        required={required}
        onChange={onInputChange}
        id={name}
        name={name}
        type={type}
        placeholder={placeholder}
        error={Boolean(errors)}
      />
      {passwordHandlers && <ShowPassword />}
      {errors && <Styles.Error isAbsolute={absolute}>{errors}</Styles.Error>}
    </Styles.Container>
  );
};

Input.defaultProps = {
  placeholder: '',
  required: false,
};

export default Input;
